import api from './api';

/**
 * System Alert service for managing system-wide alert banners
 */
const systemAlertService = {
  /**
   * Get active alerts for the current user (non-dismissed, currently active)
   * @returns {Promise<Array>}
   */
  getActiveAlerts: async () => {
    const response = await api.get('/system-alerts/active');
    return response.data;
  },

  /**
   * Dismiss an alert for the current user
   * @param {string} alertId - UUID of the alert
   * @returns {Promise<Object>}
   */
  dismissAlert: async (alertId) => {
    const response = await api.post(`/system-alerts/${alertId}/dismiss`);
    return response.data;
  },

  /**
   * Get all alerts for management (Super Admin only)
   * @returns {Promise<Array>}
   */
  getAllAlerts: async () => {
    const response = await api.get('/system-alerts/');
    return response.data;
  },

  /**
   * Create a new system alert (Super Admin only)
   * @param {Object} alertData - Alert data (message, severity, is_enabled, start_date, end_date)
   * @returns {Promise<Object>}
   */
  createAlert: async (alertData) => {
    const response = await api.post('/system-alerts/', alertData);
    return response.data;
  },

  /**
   * Update an existing alert (Super Admin only)
   * @param {string} alertId - UUID of the alert
   * @param {Object} alertData - Updated alert data
   * @returns {Promise<Object>}
   */
  updateAlert: async (alertId, alertData) => {
    const response = await api.put(`/system-alerts/${alertId}`, alertData);
    return response.data;
  },

  /**
   * Delete an alert (Super Admin only)
   * @param {string} alertId - UUID of the alert
   * @returns {Promise<void>}
   */
  deleteAlert: async (alertId) => {
    await api.delete(`/system-alerts/${alertId}`);
  }
};

export default systemAlertService;
